import { motion } from "motion/react";
import {
  Camera,
  Database,
  DollarSign,
  MapPin,
  Scan,
  ShoppingCart,
  Star,
  Tag,
  Wifi,
} from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const FEATURE_ICONS = [
  Scan,
  Star,
  Camera,
  Tag,
  MapPin,
  DollarSign,
  ShoppingCart,
  Wifi,
  Database,
] as const;

export function FeaturesGrid() {
  const { messages } = useI18n();
  const f = messages.features;

  return (
    <section id="features" className="bg-[#F7F7F5] py-32">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-6 text-4xl text-[#111111] lg:text-6xl">
            {f.heading}
          </h2>
          <p className="mx-auto max-w-2xl text-xl text-gray-600">
            {f.subheading}
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {f.items.map((feature, index) => {
            const Icon = FEATURE_ICONS[index];
            if (!Icon) return null;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                whileHover={{ y: -8, transition: { duration: 0.2 } }}
                className="rounded-3xl border border-gray-100 bg-white p-8 shadow-sm transition-all duration-300 hover:shadow-xl"
              >
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#4CAF50]">
                  <Icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="mb-3 text-xl text-[#111111]">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
